import React from 'react'
import './Content.css'

const Content = ({ children }) => {
  return <div className="fmbm-content">{children}</div>
}

export default Content



// WEBPACK FOOTER //
// ./src/Components/Content/Content.js